export const CUSTOM_CODES_POSITION = {
    HEAD: 1,
    BODY_START: 2,
    BODY_END: 3,
    MAIN_CONTENT_START: 4,
    MAIN_CONTENT_END: 5,
};
